import { WuiDateRangeInput as _WuiDateRangeInput, WuiDateRangeInputWithPresets as _WuiDateRangeInputWithPresets, WuiIcon as _WuiIcon, } from './components';
import { PUBLIC_UTILS } from './public-utils';
/**
 * Add extra meta to component
 */
function extend(component, extra) {
    for (const key in extra) {
        if (Object.hasOwn(extra, key) && !['is', 'observedAttributes'].includes(key)) {
            const element = extra[key];
            component[key] = element;
        }
    }
    return component;
}
export const WuiDateRangeInput = extend(_WuiDateRangeInput, PUBLIC_UTILS.Components.WuiDateRangeInput);
export const WuiDateRangeInputWithPresets = extend(_WuiDateRangeInputWithPresets, PUBLIC_UTILS.Components.WuiDateRangeInputWithPresets);
export const WuiIcon = extend(_WuiIcon, PUBLIC_UTILS.Components.WuiIcon);
